/* GridRowComponent.js */

"use strict";

const _ = require('lodash');
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./GridRowRenderer");

class GridRowComponent extends EventEmitter {

    constructor(configOptions) {
        super();

        this._id = _.get(configOptions, 'id');
        this._entity = _.get(configOptions, 'entity');
        this._columnOrder = _.get(configOptions, 'columnOrder');
        this._columnComponents = _.get(configOptions, 'columnComponents');
        this._selected = _.get(configOptions, 'selected', false);
        this._nestedLevel = _.get(configOptions, 'nestedLevel');
        this._parentId = _.get(configOptions, 'parentId');
        
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){
        this._entity.on('PropertiesUpdated', this._onEntityPropertiesUpdated = this._onEntityPropertiesUpdated.bind(this));
    }
    _unregisterListeners(){
        this._entity.removeListener('PropertiesUpdated', this._onEntityPropertiesUpdated);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._id = undefined;
            this._entity = undefined;
            this._columnOrder = undefined;
            this._columnComponents = undefined;
            this._selected = undefined;
            this._nestedLevel = undefined;
            this._parentId = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /**
     * @private Fired when this Entity's properties have been updated in the system.
     * @param {object} newProperties - The properties after the update.
     * @param {object} oldProperties - The properties before the update.
     * @param {JsonPatch|null} pendingPatches - The current pending patches. When the properties are updated
     * from the system the pending changes are rebased and if there are still differences the entity will stay
     * in a dirty state and the pending changes will now reflect only what is different between this entity and
     * the pristine version in the system.
     */
    _onEntityPropertiesUpdated(newProperties /*, oldProperties, pendingPatches*/){
        this._updateEntityProperties(newProperties);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    
    _triggerRowUserSelected(event){
        this.emit('RowUserSelected', this._rowData, event);
    }

    _triggerRowUserDoubleClicked(event){
        this.emit('RowUserDoubleClicked', this._rowData, event);
    }

    _triggerRowAction(eventData){
        let rowEvent = {
            rowId: this.getId(),
            eventData: eventData
        };
        this.emit('RowAction', rowEvent);
    }

    _updateEntityProperties(newProperties){
        this.emit('UpdateEntityProperties', newProperties);
        return this;
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setId(newVal){
        this._id = newVal;
        this.emit('ID', this._id);
        return this;
    }
    getId(){
        return this._id;
    }

    setEntity(newVal){
        this._entity = newVal;
        this.emit('Entity', this._entity);
        return this;
    }
    getEntity(){
        return this._entity;
    }

    setColumnOrder(newVal){
        this._columnOrder = newVal;
        this.emit('ColumnOrder', this._columnOrder);
        return this;
    }
    getColumnOrder(){
        return this._columnOrder;
    }

    setColumnComponents(newVal){
        this._columnComponents = newVal;
        this.emit('ColumnComponents', this._columnComponents);
        return this;
    }
    getColumnComponents(){
        return this._columnComponents;
    }

    setSelected(newVal, mimicUserClick){
        if (this._selected !== newVal) {
            this._selected = newVal;
            this.emit('Selected', this._selected, mimicUserClick);
        }
        return this;
    }
    getSelected(){
        return this._selected;
    }

    setNestedLevel(newVal){
        this._nestedLevel = newVal;
        this.emit('NestedLevel', this._nestedLevel);
        return this;
    }
    getNestedLevel(){
        return this._nestedLevel;
    }

    setParentId(newVal){
        this._parentId = newVal;
        this.emit('ParentId', this._parentId);
        return this;
    }
    getParentId(){
        return this._parentId;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = GridRowComponent;